/* eslint-disable import/no-duplicates */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Icon from 'vue-elmec-style/icons/glyphicon'
import IconLocal from '../src/style/glyphicon'
import Toasted from 'vue-toasted'
import VeeValidate from 'vee-validate'
import Validator from 'vee-validate'
import VueResource from 'vue-resource'
import VueClip from 'vue-clip'
import VueAnalytics from 'vue-analytics'
import axios from 'axios'
import 'bootstrap/dist/css/bootstrap.min.css'

Vue.use(VueResource)
Vue.use(VeeValidate)
Vue.use(Validator)
Vue.use(Toasted)
Vue.use(VueClip)
Vue.use(VueAnalytics, {
  id: 'UA-124437493-1',
  router,
  debug: {
    enabled: false,
    sendHitTask: (process.env.NODE_ENV === 'production')
  }
})

Vue.component('icon', Icon)
Vue.component('icon-loc', IconLocal)

Vue.config.productionTip = false

let makeID = function () {
  let text = ''
  let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  for (let i = 0; i < 5; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  }
  return text
}

axios.interceptors.request.use(function (config) {
  config.url = 'https://apiconfiguratore3d.elmec.com' + config.url
  // config.url = 'http://127.0.0.1:5002' + config.url
  config.url = config.url + (config.url.indexOf('?') === -1 ? ('?') : '&') + 'noCache=' + makeID()
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

Vue.directive('two-dec', {
  inserted: function (el) {
    el.innerHTML = parseFloat(el.innerText).toFixed(2) + ' &euro;'
  }
})
Vue.directive('two-dec-mm', {
  inserted: function (el) {
    if (el.innerText.trim() !== '') {
      el.innerHTML = parseFloat(el.innerText).toFixed(2) + ' mm'
    } else {
      el.innerHTML = 0.00 + ' mm'
    }
  }
})
Vue.directive('two-dec-mm3', {
  inserted: function (el) {
    el.innerHTML = parseFloat(el.innerText).toFixed(2) + ' mm<SUP>3</SUP>'
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js